import { action, createRequestTypes } from '../base';

export const stockMasterActionTypes = {
  GET_BATCHES_DATA: createRequestTypes('GET_BATCHES_DATA'),
  UPDATE_BATCH_DATA: createRequestTypes('UPDATE_BATCH_DATA'),
  ADJUST_BATCH: createRequestTypes('ADJUST_BATCH'),
  DELETE_BATCH_DATA: createRequestTypes('DELETE_BATCH_DATA'),
  GET_PRODUCT_LIST: createRequestTypes('GET_PRODUCT_LIST'),
  GET_PRODUCT_LIST_BY_ID: createRequestTypes('GET_PRODUCT_LIST_BY_ID'),
  CREATE_PRODUCT_LIST: createRequestTypes('CREATE_PRODUCT_LIST'),
  UPDATE_PRODUCT_LIST: createRequestTypes('UPDATE_PRODUCT_LIST'),
  ADD_PRODUCT_TO_LIST: createRequestTypes('ADD_PRODUCT_TO_LIST'),
  REMOVE_PRODUCT_FROM_LIST: createRequestTypes('REMOVE_PRODUCT_FROM_LIST'),
};

class StockMasterActions {
    /**
     * @param payload
     * @return data
     */
    getBatches = (payload, callback) => action(stockMasterActionTypes.GET_BATCHES_DATA.REQUEST, {
      payload,
      callback,
    })

    /**
     *
     * @param getBatches
     * @return {{type: *}}
     */
    getBatchesLoading = (getBatchesDataLoading) => action(stockMasterActionTypes.GET_BATCHES_DATA.LOADING, {
      getBatchesDataLoading,
    })

    /**
     * @param batchesData
     * @param orgPos
     * @return {{type: *}}
     */
    getBatchesSuccess = (batchesData) => action(stockMasterActionTypes.GET_BATCHES_DATA.SUCCESS, {
      batchesData,
    })

    /**
     * @param {*} payload
     * @param {*} callback
     * @param updateBatches
     * @return
     */
    updateBatches = (payload, callback) => action(stockMasterActionTypes.UPDATE_BATCH_DATA.REQUEST, {
      payload,
      callback,

    })

    /**
     *
     * @param updateBatchesLoading
     * @return {{type: *}}
     */
    updateBatchesLoading = (updateBatchesLoading) => action(stockMasterActionTypes.UPDATE_BATCH_DATA.LOADING, {
      updateBatchesLoading,
    })

   adjustBatches = (payload, callback) => action(stockMasterActionTypes.ADJUST_BATCH.REQUEST, {
     payload,
     callback,
   })

    /**
     *
     * @param updateBatchesLoading
     * @return {{type: *}}
     */
    adjustBatchesLoading = (adjustBatchesLoading) => action(stockMasterActionTypes.ADJUST_BATCH.LOADING, {
      adjustBatchesLoading,
    })

    /**
     * @param {*} payload
     * @param {*} callback
     * @param deleteBatches
     * @return
     */
    deleteBatches = (payload, callback) => action(stockMasterActionTypes.DELETE_BATCH_DATA.REQUEST, {
      payload,
      callback,

    })

    /**
     *
     * @param deleteBatchesLoading
     * @return {{type: *}}
     */
    deleteBatchesLoading = (deleteBatchesLoading) => action(stockMasterActionTypes.DELETE_BATCH_DATA.LOADING, {
      deleteBatchesLoading,
    })

    getProductList = (payload, callback) => action(stockMasterActionTypes.GET_PRODUCT_LIST.REQUEST, {
      payload, callback,
    })

    getProductListLoading = (getProductListLoading) => action(stockMasterActionTypes.GET_PRODUCT_LIST.LOADING, {
      getProductListLoading,
    })

    getProductListSuccess = (productLists) => action(stockMasterActionTypes.GET_PRODUCT_LIST.SUCCESS, {
      productLists,
    })

    getProductListById = (payload, callback) => action(stockMasterActionTypes.GET_PRODUCT_LIST_BY_ID.REQUEST, {
      payload, callback,
    })

    getProductListByIdLoading = (getProductListByIdLoading) => action(stockMasterActionTypes.GET_PRODUCT_LIST_BY_ID.LOADING, {
      getProductListByIdLoading,
    })

    getProductListByIdSuccess = (selectedProductList) => action(stockMasterActionTypes.GET_PRODUCT_LIST_BY_ID.SUCCESS, {
      selectedProductList,
    })

    createProductList = (payload, callback) => action(stockMasterActionTypes.CREATE_PRODUCT_LIST.REQUEST, {
      payload, callback,
    })

    createProductListLoading = (createProductListLoading) => action(stockMasterActionTypes.CREATE_PRODUCT_LIST.LOADING, {
      createProductListLoading,
    })

    createProductListSuccess = (createdProductList) => action(stockMasterActionTypes.CREATE_PRODUCT_LIST.SUCCESS, {
      createdProductList,
    })

    updateProductList = (payload, callback) => action(stockMasterActionTypes.UPDATE_PRODUCT_LIST.REQUEST, {
      payload, callback,
    })

    updateProductListLoading = (updateProductListLoading) => action(stockMasterActionTypes.UPDATE_PRODUCT_LIST.LOADING, {
      updateProductListLoading,
    })

    addProductToList = (payload, callback) => action(stockMasterActionTypes.ADD_PRODUCT_TO_LIST.REQUEST, {
      payload, callback,
    })

    addProductToListLoading = (addProductToListLoading) => action(stockMasterActionTypes.ADD_PRODUCT_TO_LIST.LOADING, {
      addProductToListLoading,
    })

    addProductToListSuccess = (createdProductList) => action(stockMasterActionTypes.ADD_PRODUCT_TO_LIST.SUCCESS, {
      createdProductList,
    })

    removeProductFromList = (payload, callback) => action(stockMasterActionTypes.REMOVE_PRODUCT_FROM_LIST.REQUEST, {
      payload, callback,
    })

    removeProductFromListLoading = (removeProductFromListLoading) => action(stockMasterActionTypes.REMOVE_PRODUCT_FROM_LIST.LOADING, {
      removeProductFromListLoading,
    })

    removeProductFromListSuccess = (updatedList) => action(stockMasterActionTypes.REMOVE_PRODUCT_FROM_LIST.SUCCESS, {
      updatedList,
    })

}

export default new StockMasterActions();
